import { render, staticRenderFns } from "./empty-state.vue?vue&type=template&id=bedcba22&scoped=true"
import script from "./empty-state.vue?vue&type=script&lang=js"
export * from "./empty-state.vue?vue&type=script&lang=js"
import style0 from "./empty-state.vue?vue&type=style&index=0&id=bedcba22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedcba22",
  null
  
)

export default component.exports